(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["forteller-sticky-cta"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.FortellerStickyCTA) return;
    window.FortellerStickyCTA = true;
    function init () {
      var bar = document.querySelector('[data-sticky-cta]');
      if (!bar) return;
      // Watch the hero section. If there's no .forteller-hero, stay hidden.
      var hero = document.querySelector('.forteller-hero');
      if (!hero) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            bar.classList.remove('is-visible');
            bar.setAttribute('aria-hidden', 'true');
          } else {
            bar.classList.add('is-visible');
            bar.setAttribute('aria-hidden', 'false');
          }
        });
      }, { threshold: 0.05 });
      io.observe(hero);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }());
  } catch(e) { console.error(e); }
})();

})();
